<template>
    <div id="pie-echart"></div>
  </template>
  
  <script>
  import echarts from "echarts";
  export default {
    data() {
      return {
        chart2: null
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.initChart()
      })
      window.addEventListener("resize", this.resize);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resize);   
      if (!this.chart2) {
        return
      }
      this.chart2.dispose()
      this.chart2 = null
    },
    methods: {
      initChart() {
        this.chart2 = echarts.init(document.getElementById("pie-echart"));
        var data = [
                      {value:75, name:'在卫生执法中发现'},
                      {value:53, name:'检验机构检测报告的'},
                      {value:32, name:'社会投诉举报'},
                      {value:16, name:'上级卫生行政机关交办'},
                      {value:8, name:'其他部门移送的'}
                  ]
        var sum = 0
        data.forEach((v, i) => {
          sum = sum + v.value;
        })
        let options = {
          tooltip : {
              trigger: 'item',
              formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          color:['#185EFC','#3A96F5','#20C744','#FE783B','#F8DA3A'],
          legend: {
              orient: 'vertical',
              icon:'rect',
              x: '46%',
              y:'19%',
              itemWidth: 10,
              itemHeight: 10,
              data: ['在卫生执法中发现','检验机构检测报告的','社会投诉举报','上级卫生行政机关交办','其他部门移送的'],
              textStyle: {
                rich: {
                    a: {
                        color: '#000',
                        width: 140
                    },
                    b0: {
                        color: '#185EFC',
                        fontFamily:'shuzi2',
                        fontSize: 16,
                        padding: [2, 15, 2, 15]
                    },
                    b1: {
                        color: '#3A96F5',
                        fontFamily:'shuzi2',
                        fontSize: 16,
                        padding: [2, 15, 2, 15]
                    },
                    b2: {
                        color: '#20C744',
                        fontFamily:'shuzi2',
                        fontSize: 16,
                        padding: [2, 15, 2, 15]
                    },
                    b3: {
                        color: '#FDB36A',
                        fontFamily:'shuzi2',
                        fontSize: 16,
                        padding: [2, 15, 2, 15]
                    },
                    b4: {
                        color: '#FE783B',
                        fontFamily:'shuzi2',
                        fontSize: 16,
                        padding:[2, 15, 2, 15]
                    },
                    b5: {
                        color: '#F8DA3A',
                        fontFamily:'shuzi2',
                        fontSize: 16,
                        padding: [2, 15, 2, 15]
                    }
                  }
                },
              formatter: function(name) {
                  let title = ''
                  var total = 0;
                  var target;
                  var pres;
                  var index;
                  for (var i = 0, l = data.length; i < l; i++) {
                      if (data[i].name == name) {
                          target = data[i].value;
                          pres = (data[i].value / sum * 100).toFixed(1) + "%";
                          title = data[i].label
                          index = i < 6 ? i : 5
                      }
                  }
                  return `{a| ${name}}{b${index}| ${target}}`+''+`{b${index}| ${pres}}`
              }
          },
          series : [
              {
                  name: '案件来源',
                  type: 'pie',
                  radius : ['45%','64%'],
                  center: ['27%', '50%'],
                  data:data,
                  itemStyle: {
                      emphasis: {
                          shadowBlur: 10,
                          shadowOffsetX: 0,
                          shadowColor: 'rgba(0, 0, 0, 0.5)'
                      }
                  },
                  itemStyle: {
                      normal: {
                          label:{ 
                                show: false, 
    //	                            position:'inside',
                                formatter: '{b} : {c} ({d}%)' 
                            }
                      },
                        labelLine :{show:true}
                  }
              }
          ]
        }
        this.chart2.setOption(options
          )
      },
        resize(){
            if(this.chart2){
                this.chart2.resize();
            }
        }
    }
  }
  </script>

<style scoped>
#pie-echart{ width: 100%; height: 100%;}
</style>
  